import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import axios from 'axios';
import { ApiClientService } from 'src/app/services/apiClient.service';
import { GlobalService } from 'src/app/services/global.service';
import { RemoteDataService } from 'src/app/services/remoteData.service';

@Component({
    selector: 'app-accessibility-statement-modal',
    templateUrl: './accessibility-statement-modal.component.html',
    styleUrls: ['./accessibility-statement-modal.component.scss']
})
export class AccessibilityStatementModalComponent implements OnInit {

    @Output() closeModal = new EventEmitter();
    public statement: string;

    constructor(private globalService: GlobalService, private remoteDataService: RemoteDataService) { }

    ngOnInit() {
        (async () => {
            const statement = await this.remoteDataService.getStatement();
            if(!statement.error){
                this.statement = statement;
            }
        })()
    }

    isMobile(){
        return this.globalService.isMobile;
    }

}